import {
  Save,
  Send,
  Clock,
  AlertCircle,
  AlertTriangle,
  CheckCircle2,
  ShieldCheck,
} from 'lucide-react';
import type { ValidationResult } from './types';

interface TimesheetFooterProps {
  totalHours: number;
  sheetStatus: string;
  saving: boolean;
  loadingData: boolean;
  isLocked: boolean;
  validationResult: ValidationResult;
  isDelegateMode: boolean;
  onSaveDraft: () => void;
  onSignAndSubmit: () => void;
}

export function TimesheetFooter({
  totalHours,
  sheetStatus,
  saving,
  loadingData,
  isLocked,
  validationResult,
  isDelegateMode,
  onSaveDraft,
  onSignAndSubmit,
}: TimesheetFooterProps) {
  return (
    <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: 'white', padding: '20px 30px', boxShadow: '0 -4px 30px rgba(0,0,0,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 100, borderTop:'1px solid #e2e8f0' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ fontSize: '0.85rem', color: '#64748b', textTransform:'uppercase', fontWeight:'600' }}>TOTAL SEMAINE</span>
        <span style={{ fontSize: '1.8rem', fontWeight: '800', color: '#1e293b' }}>{totalHours} h</span>
      </div>
      <div style={{ display: 'flex', gap: '16px' }}>
        {!isLocked && <button onClick={onSaveDraft} disabled={saving || loadingData} style={{ padding: '16px 32px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '14px', fontSize: '1.1rem', fontWeight: '600', cursor: 'pointer', display:'flex', alignItems:'center', gap:'10px' }}>
          <Save size={24} /> {saving ? '...' : 'Sauvegarder'}
        </button>}
        {isLocked ?
           <button disabled style={{ padding: '16px 32px', background: sheetStatus === 'validated' ? '#dcfce7' : '#f1f5f9', color: sheetStatus === 'validated' ? '#166534' : '#94a3b8', border: `1px solid ${sheetStatus === 'validated' ? '#86efac' : '#e2e8f0'}`, borderRadius: '14px', fontSize: '1.1rem', fontWeight: '600', cursor: 'not-allowed', display:'flex', alignItems:'center', gap:'10px' }}>
             {sheetStatus === 'validated' ? <ShieldCheck size={24} /> : <Clock size={24} />} <span>{sheetStatus === 'validated' ? 'Validé' : 'En attente validation'}</span>
           </button>
           : (() => {
               const hasErrors = validationResult.errors.length > 0;
               const hasWarnings = validationResult.warnings.length > 0;
               const errorLabel = `${validationResult.errors.length} erreur(s) à corriger`;
               return <button
               onClick={onSignAndSubmit}
               disabled={saving || loadingData || hasErrors}
               style={{
                 padding: '16px 40px',
                 background: hasErrors ? '#94a3b8' : (hasWarnings ? '#f59e0b' : '#2563eb'),
                 color: 'white',
                 border: 'none',
                 borderRadius: '14px',
                 fontSize: '1.1rem',
                 fontWeight: '600',
                 cursor: hasErrors ? 'not-allowed' : 'pointer',
                 boxShadow: hasErrors ? 'none' : (hasWarnings ? '0 4px 6px rgba(245,158,11,0.3)' : '0 4px 6px rgba(37,99,235,0.3)'),
                 display:'flex',
                 alignItems:'center',
                 gap:'10px',
                 opacity: hasErrors ? 0.7 : 1,
                 position: 'relative'
               }}
               title={hasErrors ? errorLabel : (hasWarnings ? `${validationResult.warnings.length} avertissement(s)` : '')}
             >
             {hasErrors ? <AlertCircle size={24} /> : (hasWarnings ? <AlertTriangle size={24} /> : (isDelegateMode ? <CheckCircle2 size={24} /> : <Send size={24} />))}
             <span>{hasErrors ? `Corriger (${validationResult.errors.length})` : (isDelegateMode ? 'Valider (Responsable)' : 'Signer et Envoyer')}</span>
           </button>;
           })()
        }
      </div>
    </div>
  );
}
